import type { Router } from "vue-router";

import { GOA_2026_INVITE_URL } from "@/constants/goa2026Campaign";

/** Campaign routes that stay public without account setup. */
export const GOA_2026_PUBLIC_ROUTE_NAMES = new Set([
  "goa-2026-landing",
  "goa-2026-leaderboard",
  "goa-2026-print",
]);

export function isGoa2026PublicRoute(routeName: string | symbol | null | undefined): boolean {
  return typeof routeName === "string" && GOA_2026_PUBLIC_ROUTE_NAMES.has(routeName);
}

export function buildGoa2026InvitePath(referralCode?: string | null): string {
  if (!referralCode) return GOA_2026_INVITE_URL;
  return `${GOA_2026_INVITE_URL}?ref=${encodeURIComponent(referralCode)}`;
}

export interface Goa2026CampaignEntryUser {
  accountSetup?: boolean;
}

export interface Goa2026CampaignEntryOptions {
  router: Router;
  isAuthenticated: boolean;
  user: Goa2026CampaignEntryUser | null | undefined;
  referralCode?: string | null;
  enroll: (referralCode?: string) => Promise<unknown>;
}

/**
 * Continue the GOA campaign funnel after auth:
 * login → account setup (if needed) → enroll → invite.
 */
export async function continueGoa2026CampaignEntry({
  router,
  isAuthenticated,
  user,
  referralCode,
  enroll,
}: Goa2026CampaignEntryOptions): Promise<void> {
  const invitePath = buildGoa2026InvitePath(referralCode);

  if (!isAuthenticated) {
    await router.push({
      name: "login",
      query: { redirect: invitePath },
    });
    return;
  }

  if (user?.accountSetup === false) {
    await router.push({
      name: "setup",
      query: { redirect: invitePath },
    });
    return;
  }

  await enroll(referralCode ?? undefined);
  await router.push(invitePath);
}
